const PROFILE_DIRECT_MESSAGE_SOURCE = '2';

export { PROFILE_DIRECT_MESSAGE_SOURCE };
